import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAccountStore } from "../../../stores/account/account.store";
import { Appointment } from "../../../stores/appointment/appointment.types";
import { ErrorAlertProps } from "../../../components/ErrorAlert/ErrorAlert";

type Params = {
  appointmentId: string;
};

export type RescheduleNotAllowedState = {
  error?: ErrorAlertProps;
  appointment: Appointment;
  appointmentId: string;
};

export default function useRescheduleNotAllowed(): RescheduleNotAllowedState {
  const { appointmentId } = useParams<Params>();
  const [
    error,
    fetchAppointmentDetails,
    appointment,
  ] = useAccountStore((state) => [
    state.error,
    state.fetchAppointmentDetails,
    state.appointmentMap[appointmentId],
  ]);

  useEffect(() => {
    fetchAppointmentDetails(appointmentId);
  }, [fetchAppointmentDetails, appointmentId]);

  return {
    error,
    appointment,
    appointmentId,
  };
}
